import {Act} from '@gongxigames/framework/slotV2/fsm/acts/Act';
import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

/**
 * SyncUIAct class is used only with SyncUIActDecorator.
 */
export class SyncUIAct extends Act {
    private _decoratorAct?: SyncUIActDecorator;
    constructor() {
        super();
        this.executeSyncInternalFunc = this.executeSyncInternal.bind(this);
    }

    protected executeSyncInternal(): void {
        if (this._decoratorAct) {
            this._decoratorAct.onExecuted = this.onExecuted;
            this._decoratorAct.execute();
        }
    }

    public set decoratorAct(value: SyncUIActDecorator) {
        this._decoratorAct = value;
    }

    public removeAllEventListeners(): void {
        this._decoratorAct?.removeAllListeners();
    }
}